import api from "../../services/api";
import type {
  GetMatchEventsResponse,
  CreateEventRequest,
  CreateEventResponse,
  SwapDisplayOrderRequest,
} from "./types";

export const eventsApi = {
  /**
   * All events logged for a match, ordered by display order (chronological).
   */
  getEventsByMatch: async (matchId: string): Promise<GetMatchEventsResponse> => {
    return api.get(`/events/match/${matchId}`);
  },

  /**
   * Log an event. The backend also writes the matching player_statistics row
   * and, for goals, recomputes the match unit score.
   */
  createEvent: async (data: CreateEventRequest): Promise<CreateEventResponse> => {
    return api.post("/events", data);
  },

  /**
   * Remove an event. The backend reverses the statistics it contributed.
   */
  deleteEvent: async (eventId: string): Promise<{ message: string }> => {
    return api.delete(`/events/${eventId}`);
  },

  /**
   * Swap two events' display order — how untimestamped events are reordered.
   */
  swapDisplayOrder: async (data: SwapDisplayOrderRequest): Promise<{ message: string }> => {
    return api.put("/events/swap-display-order", data);
  },
};
